import { render } from "./NotFound.vue?vue&type=template&id=19ca2522"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=19ca2522&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__